<script setup>
import { computed, ref } from 'vue';
import { useMessageContext } from '../../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const showGallery = ref(false);
const galleryAttachment = ref(null);

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});

const proseBubbleModifier = computed(() => {
  if (
    variant.value === MESSAGE_VARIANTS.USER ||
    variant.value === MESSAGE_VARIANTS.AGENT
  ) {
    return 'prose-bubble-light';
  }
  return 'prose-bubble';
});

const handleContentClick = event => {
  const isImageElement = event.target?.tagName === 'IMG';
  const isWrappedInLink = event.target?.closest('A');
  if (!isImageElement || isWrappedInLink) return;

  galleryAttachment.value = {
    file_type: 'image',
    data_url: event.target.src,
    message_id: Date.now(),
  };
  showGallery.value = true;
};
</script>

<template>
  <div>
    <span
      v-dompurify-html="formattedContent"
      class="prose"
      :class="proseBubbleModifier"
      @click="handleContentClick"
    />
    <GalleryView
      v-if="showGallery"
      v-model:show="showGallery"
      :attachment="galleryAttachment"
      :all-attachments="[galleryAttachment]"
      @close="showGallery = false"
      @error="showGallery = false"
    />
  </div>
</template>
